import axios from "axios";
import { SHA3 } from "sha3";

import { timedReject } from "../forms/helper";

const sentResponseToGTM = (type, page, response) => {
    window.dataLayer &&
        window.dataLayer.push({
            event: "apiResponse",
            page: "/sba/" + page,
            type: type,
            response: response
        });
};

export const requestVerifyUserId = userId => {
    const hash = new SHA3(512);
    hash.update(userId);

    const url = `${
        process.env.REACT_APP_SBA_AUTH_SERVICE
    }/authorize/?B365_ID=${hash.digest("hex")}`;
    return Promise.race([
        axios
            .get(url, {
                headers: {
                    "Cache-Control":
                        "no-cache, no-store, must-revalidate, max-age=-1"
                }
            })
            .then(response => {
                sentResponseToGTM("verifyUserId", "userId", response.data);
                return response.data;
            }),
        timedReject(10000, "API request timed out")
    ]);
};

export const requestVerifyCode = (uuid, code) => {
    const url = `${process.env.REACT_APP_SBA_AUTH_SERVICE}/authorize/`;

    return Promise.race([
        axios
            .post(
                url,
                {
                    uuid: uuid,
                    code: code
                },
                {
                    headers: {
                        "Cache-Control":
                            "no-cache, no-store, must-revalidate, max-age=-1"
                    }
                }
            )
            .then(response => {
                sentResponseToGTM("verifyOTP", "requireCode", response.data);
                return response.data;
            })
            .catch(error => {
                sentResponseToGTM(
                    "verifyOTP",
                    "requireCode",
                    error.response.data
                );
                throw error.response.data;
            }),
        timedReject(10000, "API request timed out")
    ]);
};
